import "../components/admin_search.js";
import "./modal.js";
import "./link_dialog/link_dialog_interface.js";

/**
 * @module page-builder
 */
(function () {
  "use strict";

  var resolveUrl = function resolveUrl(url) {
    var transformedUrl = url.replace(/sparkle:\/\//, "/").replace(/#.*/, "");
    return jQuery.get("/admin" + transformedUrl + "/meta_data.json");
  };

  Sparkle.PageBuilder.LinkDialog = LinkDialogInterface;
  Sparkle.PageBuilder.resolveUrl = resolveUrl;
})();
